import { PhoneSearchResult, Customer } from 'model/PhoneSearch';
import { PhoneSearchDto, CustomerDto } from './phoneSearchDtos';
import { ProspectDto } from 'actions/prospectMessage/prospectMessageDtos';
import { Prospect } from 'model/ProspectMessage';

export const convert = (dto: PhoneSearchDto): PhoneSearchResult => {
    let data: Customer | Prospect;

    if (dto.type === 'customer') {
        const customer = dto.data as CustomerDto;
        data = {
            id: customer.id,
            firstName: customer.first_name,
            lastName: customer.last_name,
            email: customer.email,
            phone: customer.phone
        };
    } else {
        const prospect = dto.data as ProspectDto;
        data = {
            id: prospect.id,
            uuid: prospect.uuid,
            phone: prospect.phone
        };
    }

    return {
        id: dto.id,
        phone: dto.phone,
        type: dto.type,
        data
    };
};

export const convertResults = (dto: Array<PhoneSearchDto>): Array<PhoneSearchResult> => {
    return dto.map(convert);
};
